import { z } from "zod";

import { UserGroupSchema } from "@/dashboard/features/hub/lib/user-groups/schemas";
import { AccountUserSchema } from "@/dashboard/features/hub/lib/users/schemas";

/* ── persisted row ─────────────────────────────────────────────── */

export enum AssignedToType {
  USER = "user",
  USER_GROUP = "user_group",
}

export const AssignedToSchema = z.discriminatedUnion("type", [
  z.object({
    type: z.literal(AssignedToType.USER),
    value: AccountUserSchema,
  }),
  z.object({
    type: z.literal(AssignedToType.USER_GROUP),
    value: UserGroupSchema,
  }),
]);
export type AssignedTo = z.infer<typeof AssignedToSchema>;

export const EndUserAssignmentSchema = z.object({
  id: z.string(),
  created_at: z.string().datetime(),
  updated_at: z.string().datetime(),
  deleted_at: z.string().datetime().nullable(),
  assigned_to: AssignedToSchema,
  end_user_id: z.string(),
  tenant_id: z.string(),
});
export type EndUserAssignment = z.infer<typeof EndUserAssignmentSchema>;

/* ── create body ───────────────────────────────────────────────── */
export const MutateEndUserAssignmentInputSchema = z.object({
  assigned_to: AssignedToSchema.optional(),
});
export type MutateEndUserAssignmentInput = z.infer<typeof MutateEndUserAssignmentInputSchema>;
